import { isRecordSelected } from "../NavigatorStore";
import entityFieldMetaStore from "data/meta/entityFieldMetaStore";
import entityMetaStore from "data/meta/entityMetaStore";
import _or_validate from "jsmodel/_or_validate";
import isFieldHidden from "data/util/isFieldHidden";

export const getActiveRecord = (TableStore, recState) => {
    if (recState == null) return null;
    if (!TableStore.hasEntityRecord(recState.key, recState.id)) return null;
    return TableStore.getEntityProxy(recState.key, recState.id);
};

export const lastBlurredValidation = (
    fluxContext,
    TableStore,
    ActiveFormStore,
) => {
    const lbc = ActiveFormStore.getLastBlurredControl(fluxContext);
    if (lbc == null) return null;
    let ep;
    try {
        // This try catch is because focus lbc is not guaranteed to exist in the
        // table. Not the ideal solution but keeps us moving forward.
        // Example: Field within a record grid row that has been deleted.
        ep = TableStore.getEntityProxy(lbc.entityKey, lbc.recordId);
    }
    catch(err) {
        // if no record is known just return null
        return null;
    }
    const info = entityFieldMetaStore.getInfo(lbc.entityKey, lbc.fieldKey);
    return info.dqr
        ? _or_validate(info, ep.get(lbc.fieldKey), ep)
        : null;
};

export const getChildren = (record, includeAssoc = false) =>
    Object.values(getChildrenByKey(record, includeAssoc))
        .reduce((agg, rs) => agg.concat(rs), []);

export const getChildrenByKey = (record, includeAssoc = false) => {
    const fieldKeys = [];
    fieldKeys.push(...record.entityInfo.associations.csv);
    fieldKeys.push(...record.entityInfo.associations.cmv);
    if (includeAssoc) {
        fieldKeys.push(...record.entityInfo.associations.asv);
        fieldKeys.push(...record.entityInfo.associations.amv);
    }
    return fieldKeys
        .map(fk => [fk, record.get(fk)])
        .filter(([fk, v]) => v != null)
        .map(([fk, v]) => [fk, v instanceof Array ? v : [v]])
        .filter(([fk, v]) => v.length > 0)
        .reduce((result, [fk, v]) => ({
            ...result,
            [fk]: v,
        }), {});
};

export const navTreeHelperBuilder = navState => {
    const helper = (ep, includeFields = true) => {
        if (process.env.NODE_ENV !== "production" && typeof includeFields !== "boolean") {
            throw new Error("Non-boolean passed for includeFields: " + includeFields);
        }
        const item = {
            entityKey: ep.entityKey,
            implKey: ep.entityInfo.implKey,
            id: ep.id,
            selected: isRecordSelected(navState, ep.entityKey, ep.id),
            label: ep.getLabel(),
            fields: includeFields ? ep.entityInfo.associations.cmv
                .map(k => entityFieldMetaStore.getInfo(ep.entityKey, k))
                .filter(it => it.navigable && ep.isFieldEnabled(it) && !isFieldHidden(ep.entityKey, it))
                .map(it => {
                    const oei = entityMetaStore.getInfo(it.otherEntityKey);
                    const creatables = oei.canCreate && it.autoManageKey == null ? [{
                        key: oei.key,
                        name: oei.name,
                        implKey: oei.implKey,
                    }] : [];
                    const field = {
                        key: it.key,
                        recordKey: ep.entityKey,
                        recordId: ep.id,
                        name: it.name,
                        // no create/delete the field is auto-managed
                        creatables: creatables,
                        allowDelete: oei.canDelete && creatables.length,
                        items: ep.get(it).map(it => helper(it)),
                    };
                    field.active = field.items.some(f => f.selected);
                    return field;
                }) : [],
        };
        if (!item.selected) {
            // check down the tree
            item.selected = item.fields.some(f => f.active);
        }
        item.childCount = item.fields.reduce((n, f) => n + f.items.length, 0);
        return item;
    };
    return helper;
};

export const navTree = (TableStore, navState, key, id) => {
    const ep = TableStore.getEntityProxy(key, id);
    const item = navTreeHelperBuilder(navState)(ep);
    return {
        key: key,
        entityKey: key,
        id: ep.id,
        name: ep.entityInfo.name,
        label: ep.getLabel(),
        creatables: [],
        allowDelete: false,
        items: [item],
    };
};



// WEBPACK FOOTER //
// ./app/data/selectors/records.js